import jQuery from 'jquery';
import React from 'react';
import Configurator from './Configurator.jsx';
import Image from './ui/Image.jsx';
import Button from './ui/button/Button.jsx';
import styles from './LanCableConfigurator.styl';


/**
 * Конфигуратор LAN кабеля
 * @see http://helpdesk/Task/View/120724
 */
class LanCableConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = {
			db: null,

			filterCable: {},
			filterConnector: {},
			filterCap: {},

			item: null,

			selectedCable: null,
			selectedConnector: null,
			selectedCap: null,

			specCable: null,
			specConnector: null,
			specCap: null,

			pickConnector: false,
			pickCap: false,
		};

		this.onPickConnectorChange = this.onPickConnectorChange.bind(this);
		this.onPickCapChange       = this.onPickCapChange.bind(this);
		this.onSpecDeleteItem      = this.onSpecDeleteItem.bind(this);

		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
	}

	getType() {
		return 'lan_cable';
	}

	getCustomStyles() {
		return styles;
	}

	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;

				this.setState(() => {
					return {
						db
					};
				});
			}
		);
	}

	onChangeCableFilter(prop, value) {
		this.setState(prevState => {
			let filterCable = jQuery.extend({}, prevState.filterCable);

			if (value === '') {
				delete filterCable[prop];
			} else {
				filterCable[prop] = value;
			}

			return {
				filterCable
			};
		});
	}

	onChangeCapFilter(prop, value) {
		this.setState(prevState => {
			let filterCap = jQuery.extend({}, prevState.filterCap);

			if (value === '') {
				delete filterCap[prop];
			} else {
				filterCap[prop] = value;
			}

			return {
				filterCap
			};
		});
	}

	onSelectItem(item, type) {
		let newState = {item};

		switch (type)
		{
			case 'cable':
				newState.selectedCable = item;
				break;

			case 'connector':
				newState.selectedConnector = item;
				break;

			case 'cap':
				newState.selectedCap = item;
				break;
		}

		this.setState(newState);
	}

	onSpecListAdd(item, type) {
		switch (type)
		{
			case 'cable':
				this.setState({specCable: item},()=>{
					this.doAddToCart(this.getFullSpecList())
				});
				break;

			case 'connector':
				this.setState({specConnector: item}, ()=>{
					this.doAddToCart(this.getFullSpecList())
				});
				break;

			case 'cap':
				this.setState({specCap: item},()=>{
					this.doAddToCart(this.getFullSpecList())
				});
				break;
		}
	}
	doAddToCart(items){
	const goods = JSON.stringify(
	{
		products: items.map(i => {
		if(i===null){
			return
		}else {
			return {
				cnt: i.count || 1,
				art: i.article,
				name: i.name,
			}
		}
		})
	}
)
	console.log(goods);
	// Отправка JSON в ipro
	window.top.postMessage(goods, '*')
}

	onPickConnectorChange(event) {
		this.setState({
			pickConnector: event.target.checked
		});
	}

	onPickCapChange(event) {
		this.setState({
			pickCap: event.target.checked
		});
	}


	getCableList() {
		if (jQuery.isEmptyObject(this.state.filterCable)) {
			return this.state.db.cables;
		}

		return this.state.db.cables.filter(cable => {
			for (const filterPropName in this.state.filterCable)
			{
				if (this.state.filterCable[filterPropName] !== cable[filterPropName]) {
					return false;
				}
			}
			return true;
		});
	}

	getConnectorList() {
		if (!this.state.specCable) {
			return [];
		}

		return this.state.db.connectors.filter(connector => {
			for (let i = 0; i < this.state.db.connector2cable.length; i++)
			{
				const con2cable = this.state.db.connector2cable[i];
				if (con2cable.cable_article === this.state.specCable.article && con2cable.connector_article === connector.article) {
					return true;
				}
			}
			return false;
		});
	}

	getCapList() {
		if (!this.state.specConnector) {
			return [];
		}

		if (jQuery.isEmptyObject(this.state.filterCap)) {
			return this.state.db.caps;
		}

		let caps = this.state.db.caps.filter(cap => {
			for (let i = 0; i < this.state.db.cap2connector.length; i++)
			{
				const cap2connector = this.state.db.cap2connector[i];

				if (cap2connector.connector_article === this.state.specConnector.article && cap2connector.cap_article === cap.article) {
					return true;
				}
			}

			return false;
		});

		caps = caps.filter(cap => {
			for (const filterPropName in this.state.filterCap)
			{
				const filterVal = this.state.filterCap[filterPropName];

				if (filterVal !== cap[filterPropName]) {
					return false;
				}
			}

			return true;
		});

		return caps;
	}

	getFilter(itemList, filterList, name, selectedFilter, itemListFn) {
		if (itemList.length === 0) {
			return [];
		}

		// Если выбран данный фильтр, временно убираем его, для получения всех вариантов по этому свойству
		if (selectedFilter && selectedFilter[name])
		{
			const tmp = selectedFilter[name];

			delete selectedFilter[name];

			const lst = itemListFn.call(this);

			selectedFilter[name] = tmp;

			return this.getFilter(lst, filterList, name);
		}

		return filterList.filter(filterItem => {
			for (let i = 0; i < itemList.length; i++) {
				if (itemList[i][name] === filterItem) {
					return true;
				}
			}
			return false;
		});
	}

	onSpecDeleteItem(item) {

		if (this.state.item && this.state.item.article === item.article) {
			this.setState({
				item: null
			});
		}

		if (this.state.selectedCable && this.state.selectedCable.article === item.article)
		{
			this.setState({
				selectedCable: null,
				specCable: null
			});

			return;
		}
		else if (this.state.selectedConnector && this.state.selectedConnector.article === item.article)
		{
			this.setState({
				selectedConnector: null,
				specConnector: null
			});

			return;
		}
		else if (this.state.selectedCap && this.state.selectedCap.article === item.article)
		{
			this.setState({
				selectedCap: null,
				specCap: null
			});

			return;
		}
	}

	doPrint(params) {
		let _params = params || {};

		_params.data = {
			speclist: JSON.stringify(this.getFullSpecList())
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	/**
	 * Возвращает полный перечень подобранных аксессуаров
	 */
	getFullSpecList() {
		return [this.state.specCable, this.state.specConnector, this.state.specCap];
	}


	render() {
		if (!this.state.db) {
			return <div className={styles.cfg}><div className={styles.title}>Онлайн подбор аксессуаров к LAN-кабелю ITK</div></div>;
		}

		const cableList     = this.getCableList();
		const connectorList = this.getConnectorList();
		const capList       = this.getCapList();


		const filterCableColor = this.getFilter(cableList, this.state.db.filters.cables.color, 'color', this.state.filterCable, this.getCableList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterCableCategory = this.getFilter(cableList, this.state.db.filters.cables.category, 'category', this.state.filterCable, this.getCableList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterCableShield = this.getFilter(cableList, this.state.db.filters.cables.shield, 'shield', this.state.filterCable, this.getCableList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterCableMaterial = this.getFilter(cableList, this.state.db.filters.cables.material, 'material', this.state.filterCable, this.getCableList).map(item => {
			return (<option key={item} value={item}>{item}</option>);
		});

		const filterCableShell = this.getFilter(cableList, this.state.db.filters.cables.shell, 'shell', this.state.filterCable, this.getCableList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterCableType = this.getFilter(cableList, this.state.db.filters.cables.type, 'type', this.state.filterCable, this.getCableList).map(item => {
			return (<option key={item}>{item}</option>);
		});


		const filterConnectorColor = this.getFilter(connectorList, this.state.db.filters.connectors.color, 'color', this.state.filterConnector, this.getConnectorList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterConnectorContacts = this.getFilter(connectorList, this.state.db.filters.connectors.contacts, 'contacts', this.state.filterConnector, this.getConnectorList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterConnectorCategory = this.getFilter(connectorList, this.state.db.filters.connectors.category, 'category', this.state.filterConnector, this.getConnectorList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterConnectorShield = this.getFilter(connectorList, this.state.db.filters.connectors.shield, 'shield', this.state.filterConnector, this.getConnectorList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterConnectorInsertion = this.getFilter(connectorList, this.state.db.filters.connectors.insertion, 'insertion', this.state.filterConnector, this.getConnectorList).map(item => {
			return (<option key={item}>{item}</option>);
		});

		const filterConnectorContactsMaterial = this.getFilter(connectorList, this.state.db.filters.connectors.contacts_material, 'contacts_material', this.state.filterConnector, this.getConnectorList).map(item => {
			return (<option key={item}>{item}</option>);
		});


		const filterCapColor = this.state.db.filters.caps.color.map(item => {
			return (<option key={item}>{item}</option>);
		});


		let specList = [];

		if (this.state.specCable) {
			specList.push(this.state.specCable);
		}
		if (this.state.specConnector) {
			specList.push(this.state.specConnector);
		}
		if (this.state.specCap) {
			specList.push(this.state.specCap);
		}



		return (
			<div className={styles.cfg}>
				<div className={styles.title}>Онлайн подбор аксессуаров к LAN-кабелю ITK</div>


				{/* Фильтры кабеля */}
				<select className={styles.cableFilterMaterial} onChange={event => this.onChangeCableFilter('material', event.target.value)}>
					<option value="">Все</option>
					{filterCableMaterial}
				</select>

				<select className={styles.cableFilterShield} onChange={event => this.onChangeCableFilter('shield', event.target.value)}>
					<option value="">Все</option>
					{filterCableShield}
				</select>

				<select className={styles.cableFilterCategory} onChange={event => this.onChangeCableFilter('category', event.target.value)}>
					<option value="">Все</option>
					{filterCableCategory}
				</select>

				<select className={styles.cableFilterColor} onChange={event => this.onChangeCableFilter('color', event.target.value)}>
					<option value="">Все</option>
					{filterCableColor}
				</select>

				<select className={styles.cableFilterShell} onChange={event => this.onChangeCableFilter('shell', event.target.value)}>
					<option value="">Все</option>
					{filterCableShell}
				</select>

				<select className={styles.cableFilterType} onChange={event => this.onChangeCableFilter('type', event.target.value)}>
					<option value="">Все</option>
					{filterCableType}
				</select>

				{/* Список кабелей */}
				<ArticleList
					className={styles.cableList}
					items={cableList}
					selectedItem={this.state.selectedCable}
					onSelect={item => this.onSelectItem(item, 'cable')}
				/>

				<Button
					buttonStyle={styles.btnSpecListAddCable}
					buttonDisabledStyle={styles.btnSpecListAddCableDisabled}
					iconStyle={styles.btnSpecListAddIcon}
					text="Сохранить в спецификацию"
					disabled={!this.state.selectedCable}
					onClick={() => this.onSpecListAdd(this.state.selectedCable, 'cable')}
				/>


				{/* Фильтры разъемов */}
				<label className={styles.connectorFilterCheck}><input type="checkbox"
					checked={connectorList.length > 0 && this.state.pickConnector} disabled={connectorList.length <= 0} onChange={this.onPickConnectorChange} /></label>

				<select className={styles.connectorFilterColor} disabled={!this.state.pickConnector}>
					<option value="">Все</option>
					{filterConnectorColor}
				</select>

				<select className={styles.connectorFilterContacts} disabled={!this.state.pickConnector}>
					<option value="">Все</option>
					{filterConnectorContacts}
				</select>

				<select className={styles.connectorFilterCategory} disabled={!this.state.pickConnector}>
					<option value="">Все</option>
					{filterConnectorCategory}
				</select>

				<select className={styles.connectorFilterShield} disabled={!this.state.pickConnector}>
					<option value="">Все</option>
					{filterConnectorShield}
				</select>

				<select className={styles.connectorFilterInsertion} disabled={!this.state.pickConnector}>
					<option value="">Все</option>
					{filterConnectorInsertion}
				</select>

				<select className={styles.connectorFilterContactsMaterial} disabled={!this.state.pickConnector}>
					<option value="">Все</option>
					{filterConnectorContactsMaterial}
				</select>

				{/* Список разъемов */}
				<ArticleList
					className={styles.connectorList}
					items={connectorList}
					selectedItem={this.state.selectedConnector}
					disabled={!this.state.pickConnector || !this.state.selectedCable}
					onSelect={item => this.onSelectItem(item, 'connector')}
				/>

				<Button
					buttonStyle={styles.btnSpecListAddConnector}
					buttonDisabledStyle={styles.btnSpecListAddConnectorDisabled}
					iconStyle={styles.btnSpecListAddIcon}
					text="Сохранить в спецификацию"
					disabled={!this.state.pickConnector || !this.state.selectedConnector}
					onClick={() => this.onSpecListAdd(this.state.selectedConnector, 'connector')}
				/>


				{/* Фильтры колпачков */}
				<label className={styles.capFilterCheck}><input type="checkbox"
					checked={capList.length > 0 && this.state.pickCap} disabled={capList.length <= 0} onChange={this.onPickCapChange} /></label>

				<select className={styles.capFilterColor} disabled={!this.state.pickCap} onChange={event => this.onChangeCapFilter('color', event.target.value)}>
					<option value="">Все</option>
					{filterCapColor}
				</select>

				{/* Список колпачков */}
				<ArticleList
					className={styles.capList}
					items={capList}
					selectedItem={this.state.selectedCap}
					disabled={!this.state.pickCap || !this.state.selectedConnector}
					onSelect={item => this.onSelectItem(item, 'cap')}
				/>

				<Button
					buttonStyle={styles.btnSpecListAddCap}
					buttonDisabledStyle={styles.btnSpecListAddCapDisabled}
					iconStyle={styles.btnSpecListAddIcon}
					text="Сохранить в спецификацию"
					disabled={!this.state.pickCap || !this.state.selectedCap}
					onClick={() => this.onSpecListAdd(this.state.selectedCap, 'cap')}
				/>

				<Image
					className={styles.itemImg}
					url={this.state.item && this.state.item.photo ? `itkcfg.php?type=${this.getType()}&action=getPhoto&article=${this.state.item.article}` : null}
					noPhotoSmall={true}
				/>

				{/* Описание */}
				{this.state.item && this.state.item.description ? (
					<div className={styles.description}>{this.state.item.description}</div>
				) : (
					<div className={styles.descriptionEmpty}></div>
				)}

				{/* Список спецификации */}
				<ArticleList
					className={styles.specList}
					items={specList}
					canDelete={true}
					selectedItem={this.state.item}
					onSelect={item => this.onSelectItem(item)}
					onDelete={item => this.onSpecDeleteItem(item)}
				/>


				<Button
					buttonStyle={styles.btnPdf}
					buttonDisabledStyle={styles.btnPdfDisabled}
					iconStyle={styles.btnPdfIcon}
					text="Сохранить в PDF"
					textStyle={styles.btnPdfTextStyle}
					//disabled={!this.state.item}
					onClick={this.onBtnPrintPdfClick}
				/>
				<Button
					buttonStyle={styles.btnExcel}
					buttonDisabledStyle={styles.btnExcelDisabled}
					iconStyle={styles.btnExcelIcon}
					text="Сохранить в Excel"
					textStyle={styles.btnExcelTextStyle}
					//disabled={!this.state.item}
					onClick={this.onBtnExcelClick}
				/>
				<Button
					buttonStyle={styles.btnPrint}
					buttonDisabledStyle={styles.btnPrintDisabled}
					iconStyle={styles.btnPrintIcon}
					text="Распечатать"
					textStyle={styles.btnPrintTextStyle}
					//disabled={!this.state.item}
					onClick={this.onBtnPrintClick}
				/>
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '713px'}}/>
				<a className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#76d750',
					width: '50%',
					height: '22px',
					top: '713px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '716px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.itk-group.ru/servis-i-podderzhka/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>
		);
	}
}

class ArticleList extends React.Component
{
	render() {
		if (!this.props.items) {
			return (<div className={this.props.className}></div>);
		}

		const rows = this.props.items.map((item, index) => {
			let rowClassName = index % 2 === 0 ? styles.articleListRow : styles.articleListRow_Odd;

			if (this.props.selectedItem && this.props.selectedItem.article === item.article) {
				rowClassName = styles.articleListRow_Selected;
			}

			return (
				<tr key={item.article} className={rowClassName} onClick={() => this.props.onSelect(item)}>
					<td className={styles.articleListRowArticle}>{item.article}</td>
					<td className={styles.specListTableRightColumnCell}>
						{this.props.canDelete ?
							<div className={styles.specListTableRightColumnCellWrapper}>
								<span>{item.name}</span>
								<span className={styles.specListDelete} title="Удалить позицию"
											onClick={event => {event.stopPropagation(); this.props.onDelete(item);}} />
							</div>
							:
							item.name
						}
					</td>
				</tr>
			);
		});

		return (
			<div className={this.props.className}>
				<div className={styles.articleListTableWrap}>
					<table className={styles.articleListTable}>
						<tbody>
							{rows}
						</tbody>
					</table>
				</div>
				{this.props.disabled &&
					<div className={styles.articleListDisabledWrap}></div>
				}
			</div>
		);
	}
}

export default LanCableConfigurator;



// WEBPACK FOOTER //
// ./src/react/LanCableConfigurator.jsx